module.exports = __webpack_public_path__ + "img/5.9325a6f0.jpg";